import { IWidget_Settings } from "../interface.widget-settings";

/**
 * A base class for the widgets provided by the Aelia Currency Switcher.
 *
 * @since 4.12.1.210629
 */
export abstract class Widget { // NOSONAR
	/**
		* The settings passed to the class.
		*
		* @var IWidget_Settings
		*/
	protected settings: IWidget_Settings;

	/**
	 * Constructor.
	 *
	 * @param settings IWidget_Settings
	 */
	public constructor(settings: IWidget_Settings) {
		this.settings = settings;

		// Initialise the event handlers used by the widget
		this.init_event_handlers();
	}

	/**
	 * Initialise the event handlers used by the widget.
	 */
	protected abstract init_event_handlers(): void;

	/**
	 * Purges the cart fragments. Convenience method.
	 */
	protected purge_cart_fragments(): void {
		this.settings.cart_fragments_handler.purge_cart_fragments();
	}
}